import { formatDate } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DiallerService } from '@app/dialler/services';
import { filter, take } from 'rxjs/operators';
import { WorkService } from '../services';
import { RescheduleNameandnumberCommand } from '../models';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-name-and-number',
  templateUrl: './name-and-number.component.html',
  styles: [
    `
      :host {
        display: flex;
        flex-grow: 1;
        overflow: auto;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NameAndNumberComponent implements OnInit {
  msgForm: FormGroup;
  url: SafeUrl = this.sanitizer.bypassSecurityTrustUrl('');

  url$: BehaviorSubject<SafeUrl> = new BehaviorSubject(this.url);

  constructor(
    private workSvc: WorkService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private diallerSvc: DiallerService,
    private sanitizer: DomSanitizer
  ) {
    this.msgForm = this.formBuilder.group({
      first: '',
      last: '',
      phone: '',
      callerid: '',
      notes: '',
      entered: '',
      sessionid: '',
      dnis: '',
      recording: '',
    });
  }

  cancel() {
    // need to release and redirect to work
    this.workSvc.releaseNameAndNumber(this.msgForm.get('sessionid')?.value);
    this.workSvc.recordingPlaceolders = [];
    this.workSvc.showStateModal();
  }

  contacted() {
    this.workSvc.loadNNData();
    this.workSvc.msgContacted(this.msgForm.get('sessionid')?.value);

    this.workSvc.campaignId$.pipe(take(1)).subscribe((campaignId) => {
      this.workSvc.popScript(
        campaignId!,
        0,
        'OB',
        '0',
        '', // recordings get set at submit now.
        '',
        0,
        false,
        this.msgForm.controls.phone.value
      );
      // this.workSvc.recordingPlaceolders = [];
    });
  }

  dialNumber() {
    this.diallerSvc.callManual(this.msgForm.get('phone')?.value, '', 30);
  }

  discard() {
    this.workSvc.msgContacted(this.msgForm.get('sessionid')?.value);
    this.workSvc.loadNNData();
    this.workSvc.recordingPlaceolders = [];
    this.workSvc.showStateModal();
  }

  ngOnInit(): void {
    this.workSvc.campaignId$.pipe(take(1)).subscribe((campaignId) => {
      if (campaignId === undefined || campaignId === 0) {
        // no campaign selected
        this.toastr.info('Please select a campaign');
      } else {
        if (campaignId != 0) this.workSvc.loadVoiceMailMsg(campaignId!);

        this.workSvc.voicemailMsg$
          .pipe(
            filter((vm) => vm !== undefined),
            take(1)
          )
          .subscribe((vm) => {
            if (vm === null) {
              //this.workSvc.updateMsgButtonState(false);
              this.workSvc.loadNNData();
              this.toastr.info(
                'No more voicemails available for this campaign'
              );
            } else {
              this.msgForm.setValue({
                first: vm?.first,
                last: vm?.last,
                phone: vm?.cli,
                callerid: vm?.cli,
                notes: vm?.notes,
                entered: vm?.dtEntered
                  ? formatDate(vm?.dtEntered, 'dd/MM/yyyy h:mm:ss a', 'en')
                  : '',
                sessionid: vm?.sessionId,
                dnis: vm?.dnis,
                recording: vm?.recording,
              });

              if (vm?.recording) {
                this.url = this.sanitizer.bypassSecurityTrustUrl(
                  `data:audio/wav;base64,${vm?.recording}`
                );
              }
              this.url$.next(
                this.sanitizer.bypassSecurityTrustUrl(
                  `data:audio/wav;base64,${vm?.recording}`
                )
              );

              // ;
            }
          });
      }
    });
  }

  reschedule() {
    this.workSvc.campaignId$.pipe(take(1)).subscribe((campaignId) => {
      if (campaignId != undefined && campaignId > 0) {
        var cmd: RescheduleNameandnumberCommand = {
          campaignId: campaignId!,
          dnis: this.msgForm.get('dnis')?.value,
          first: this.msgForm.get('first')?.value,
          last: this.msgForm.get('last')?.value,
          notes: this.msgForm.get('notes')?.value,
          phone: this.msgForm.get('phone')?.value,
          sessionId: this.msgForm.get('sessionid')?.value,
        };
        this.workSvc.rescheduleNameAndNumber(cmd);
        this.workSvc.loadNNData();

        this.toastr.info('Voicemail rescheduled');
        this.workSvc.recordingPlaceolders = [];
        this.workSvc.showStateModal();
      }
    });
  }
}
